import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { PromotionInfoData } from "./promotion.model";
import { TransactionType } from "../transaction/transaction.model";

export abstract class BasePromotionService {
  protected baseUrl = '';

  protected constructor(
    protected readonly http: HttpClient,
    baseUrl: string
  ) {
    this.baseUrl = `${baseUrl}/promotions`;
  }

  getByPromoCode(promoCode: string, loanId: number, transactionType: TransactionType): Observable<PromotionInfoData> {
    return this.http.get<PromotionInfoData>(`${this.baseUrl}/get-by-promo-code`, {
      params: {
        promoCode: promoCode,
        loanId: loanId,
        transactionType: transactionType
      }
    });
  }
}
